import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './plugins/element.js'
import axios from 'axios'
import  dialog from './components/index.js'
import echarts from './echarts/echarts.js'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(dialog)
Vue.use(echarts)
Vue.prototype.$axios = axios
Vue.config.productionTip = false
// eslint-disable-next-line no-console
console.log(process.env)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
